import { post,get } from "../ajax";

interface saveAccountType{
  id: number,
  userName: string,
  password: string,
  mobile: string,
  disable: boolean,
  isAdmin: boolean,
  role:string
}

export async function accountList(body:Record<string, any>){
    const url = `/api/Account/GetAccountPageList?UserName=${body.UserName}&Mobile=${body.Mobile}&PageIndex=${body.PageIndex}&PageSize=${body.PageSize}`
    const res = await get(url)
    return res;
}

export async function saveAccount(body:saveAccountType){
    const url = `/api/Account/SaveAccount`
    const res = await post(url,body)
    return res;
}

export async function changeAccount(body:{id:number,disable:boolean}){
    const url = `/api/Account/DisableOrEnableAccount`
    const res = await post(url,body)
    return res;
}

export async function relatedMerchant(body:{accountId:number,merchantIds:number[]}){
    const url = `/api/Account/RelatedMerchant`
    const res = await post(url,body)
    return res;
}